import { FormState, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/src/components/ui/form";
import { useSubscribe } from "@/src/lib/actions";
import { emptyFiltersForm, FiltersFormT } from "./filters.schema";
import { useCallback } from "react";
import { CharterTypes } from "./CharterTypes";
import { useOffersStore } from "../../../stores/offersStore";
import { Separator } from "../../../components/ui/separator";
import { Status } from "./Status";
import { StartDate } from "./StartDate";
import { Broker } from "./Broker";
import { Destination } from "./Destination";
import { Customer } from "./Customer";
import { Brand } from "./Brand";
import { Type } from "./Type";

export function FiltersForm({ onSave }: { onSave: () => void }) {
  const { filters, setFilters } = useOffersStore();
  const form = useForm<FiltersFormT>({
    resolver: zodResolver(FiltersFormT),
    defaultValues: emptyFiltersForm,
    ...(filters ? { values: { ...emptyFiltersForm, ...filters } } : {}),
    resetOptions: {
      keepDefaultValues: true,
    },
  });

  const onClear = () => {
    form.reset(emptyFiltersForm);
    setFilters({});
    onSave();
  };

  const onSubmit = useCallback(
    form.handleSubmit(
      (data) => {
        const dirtyFields = findCommonFormProps(data, form.formState.dirtyFields);
        setFilters(dirtyFields);
        onSave();
      },
      () => {
        const values = form.getValues();
        const issues = FiltersFormT.safeParse(values).error?.issues ?? [];
        console.log(issues, "errors");
      },
    ),
    [form],
  );

  useSubscribe("filters:save", onSubmit);
  useSubscribe("filters:clear", onClear);

  return (
    <Form {...form}>
      <form className="flex flex-col gap-6" onSubmit={onSubmit}>
        <Brand />
        <Type />
        <Status />
        <Separator />
        <StartDate />
        <Separator />
        <Broker />
        <Separator />
        <Customer />
        <Separator />
        <Destination defaultValue={filters?.endLocation} />
        <Separator />
        <CharterTypes />
      </form>
    </Form>
  );
}

function findCommonFormProps(
  data: FiltersFormT,
  dirties: FormState<FiltersFormT>["dirtyFields"],
): Partial<FiltersFormT> {
  const commonProps: Partial<FiltersFormT> = {};
  for (const [key, value] of Object.entries(dirties)) {
    if ((Array.isArray(value) && !!value?.length) || (!Array.isArray(value) && !!value)) {
      (commonProps as any)[key] = (data as any)[key];
    }
  }

  return commonProps;
}
